module.exports = __webpack_public_path__ + "img/biancheng.7a404c39.png";